let apidaeQuickSearch = {
    props: {
        title: String,
        nbPrestas: Number,
        type: String,
        groupesFiltres: Array,
        lang: String,
        pmin: Number,
        pmax: Number,
        showdate: Number,
        showtarif: Number
    },
    components: {
        groupFilters
    },
    directives: {
        clickaway
    },
    data() {
        return {
            isDropdownActive: false,
        }
    },
    methods: {
        save() {
            this.$root.submitfilters(event)
        },
        // pricevent() {
        //     this.$root.callfilters(event)
        //     this.isDropdownActive = false
        // },
        away() {
            this.isDropdownActive = false;
        }
    },
    template: `
    <div class="Profiles">
        <form @submit.prevent="save">
            <h2 class="h2">{{ title }}</h2>
            <div class="profile-wrapper">
                <template v-if="groupeFiltres.hide" v-for="(groupeFiltres, index) in groupesFiltres">
                    <group-filters :groupe-filtres="groupeFiltres"></group-filters>
                </template>
                <div class="text-center">
                    <button class="button large" type="submit">Voir les {{ nbPrestas }} résultats</button>
                </div>
            </div>
        </form>
    </div>`
} 
        // <div class="profile cd-filter-block" :class="{ 'is-active': isDropdownActive }">
        //     <h4 @click="isDropdownActive=!isDropdownActive" :class="(pmin != 0 || pmax != 10000) ? 'selected' : ''">Mon budget</h4>
        //     <div class="cd-filter-content cd-filter-price cd-filters list">
        //         <ul>
        //             <li :class="(pmin == '0' && pmax == '10000') ? 'selected filter' : 'filter'">
        //                 <span @click="pricevent" class="pricevent cd-filter-rbl" data-pmin="0" data-pmax="10000">Tous les prix</span>
        //             </li>
        //             <li :class="(pmin == '0' && pmax == '100') ? 'selected filter' : 'filter'">
        //                 <span @click="pricevent" class="pricevent cd-filter-rbl" data-pmin="0" data-pmax="100">Moins de 100€</span>
        //             </li>
        //             <li :class="(pmin == '100' && pmax == '200') ? 'selected filter' : 'filter'">
        //                 <span @click="pricevent" class="pricevent cd-filter-rbl" data-pmin="100" data-pmax="200">De 100€ à 200€</span>
        //             </li>
        //             <li :class="(pmin == '200' && pmax == '10000') ? 'selected filter' : 'filter'">
        //                 <span @click="pricevent" class="pricevent cd-filter-rbl" data-pmin="200" data-pmax="10000">Supérieur à 200€</span>
        //             </li>
        //         </ul>
        //         <div class="input-number">
        //             <input type="hidden" name="pmin" id="min-number-price" class="min-number autosize" v-model="pmin">
        //             <input type="hidden" name="pmax" id="max-number-price" class="max-number autosize" v-model="pmax">
        //         </div>
        //     </div>
        // </div>

//https://embed.plnkr.co/plunk/8XdCd2
if (document.querySelector('.prestaQuickSearch')) {
    document.querySelectorAll('.prestaQuickSearch').forEach(s => {
        let id = s.getAttribute('id');
        let uri = s.dataset.url;
        let title = s.dataset.title;
        let type = s.dataset.type;
        let lang = s.dataset.lang;
        let showdate = parseInt(s.dataset.showdate);
        let showtarif = parseInt(s.dataset.showtarif);
        new Vue({
            // delimiters: ['%%', '%%'],
            el: '#' + id,
            components: { apidaeQuickSearch },
            data: function () {
                return {
                    title: title,
                    nbPrestas: 0,
                    type: type,
                    groupesFiltres: [],
                    lang: lang,
                    pmin: 0,
                    pmax: 10000,
                    showdate: showdate,
                    showtarif: showtarif
                }
            },
            mounted: function() {
                fetch(apidae.site_url + uri + '/json')
                    .then(stream => stream.json())
                    .then(data => {
                        this.nbPrestas = data.items.length;
                        this.groupesFiltres = data.filtres;
                    })
                    .catch(error => console.error(error))
            },
            methods: {
                callfilters: function(event) {
                    // console.log(event);
                    loadData = true;
                    let apiUrl = apidae.site_url + uri + '/json';
                    let query = '?tri=triEvenement&searchByMap=0&zl=&slt=&slg=&nlt=&nlg=&njmin=&njmax=';

                    // if (event.target.classList.contains('pricevent')) {
                    //     this.pmin = Number(event.target.getAttribute('data-pmin'))
                    //     this.pmax = Number(event.target.getAttribute('data-pmax'))
                    // }
                    // query += '&pmin=' + this.pmin + '&pmax=' + this.pmax;

                    // console.log(this.groupesFiltres);
                    let cgroupesFiltres = this.groupesFiltres;
                    cgroupesFiltres.forEach(cgroupefiltres => {
                        let cfiltres = cgroupefiltres.listeFiltre;
                        cfiltres.forEach(cfiltre => {
                            // console.log(cfiltre.selected);
                            if (cfiltre.selected) {
                                // console.log(cfiltre.idFiltre);
                                query += '&filter' + cfiltre.idFiltre + '=' + cgroupefiltres.idGroupe;
                            }
                        });
                    });
                    // console.log(cgroupesFiltres);
                    // console.log(query);

                    fetch(apiUrl + query)
                        .then(stream => stream.json())
                        .then(data => {
                            this.nbPrestas = data.items.length;
                            this.groupesFiltres = data.filtres;
                        })
                        .catch(error => console.error(error))
                },
                submitfilters: function(event) {
                    let query =  uri + '?tri=triEvenement&searchByMap=0&zl=&slt=&slg=&nlt=&nlg=&njmin=0&njmax=8&pmin=' + this.pmin + '&pmax=' + this.pmax;
                    let cgroupesFiltres = this.groupesFiltres;
                    cgroupesFiltres.forEach(cgroupefiltres => {
                        let cfiltres = cgroupefiltres.listeFiltre;
                        cfiltres.forEach(cfiltre => {
                            // console.log(cfiltre.selected);
                            if (cfiltre.selected) {
                                console.log(cfiltre.idFiltre);
                                query += '&filter' + cfiltre.idFiltre + '=' + cgroupefiltres.idGroupe;
                            }
                        });
                    });
                    // console.log(apidae.site_url + uri);
                    window.location = apidae.site_url + query;
                }
            }
        });
    })
}
